export const PROMPT_STORAGE_ENABLED = true;

const LAST_SHOWN_KEY = "loops_reminder_prompt_last_shown_v1";
const DISMISSED_AT_KEY = "loops_reminder_prompt_dismissed_at_v1";
const SESSION_ATTEMPT_KEY = "loops_reminder_prompt_attempted_session_v2";

/** Bottom sheet — respect "Not now" for this long before offering again. */
const MIN_MS_AFTER_DISMISS = 72 * 60 * 60 * 1000;

const CONTEXT_NUDGE_DISMISSED_AT_KEY = "loops_reminder_context_dismiss_at_v1";
const MIN_MS_AFTER_CONTEXT_DISMISS = 72 * 60 * 60 * 1000;

const readTimestamp = (key) => {
  try {
    const value = parseInt(localStorage.getItem(key), 10);
    return Number.isNaN(value) ? null : value;
  } catch {
    return null;
  }
};

export const hasReminderPromptAttemptedThisSession = () => {
  if (!PROMPT_STORAGE_ENABLED) return false;
  try {
    return sessionStorage.getItem(SESSION_ATTEMPT_KEY) === "1";
  } catch {
    return false;
  }
};

export const markReminderPromptAttemptedThisSession = () => {
  if (!PROMPT_STORAGE_ENABLED) return;
  try {
    sessionStorage.setItem(SESSION_ATTEMPT_KEY, "1");
  } catch {
    /* ignore */
  }
};

/** Whether the scroll-triggered bottom sheet may show this session. */
export const shouldOfferReminderPrompt = (now = Date.now()) => {
  if (!PROMPT_STORAGE_ENABLED) return true;
  try {
    const dismissedAt = readTimestamp(DISMISSED_AT_KEY);
    if (dismissedAt != null && now - dismissedAt < MIN_MS_AFTER_DISMISS) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

export const markReminderPromptShown = () => {
  if (!PROMPT_STORAGE_ENABLED) return;
  try {
    localStorage.setItem(LAST_SHOWN_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
};

export const markReminderPromptDismissed = () => {
  if (!PROMPT_STORAGE_ENABLED) return;
  try {
    const now = Date.now();
    localStorage.setItem(DISMISSED_AT_KEY, String(now));
    localStorage.setItem(LAST_SHOWN_KEY, String(now));
  } catch {
    /* ignore */
  }
};

export const shouldShowReminderContextNudge = (now = Date.now()) => {
  try {
    const dismissedAt = readTimestamp(CONTEXT_NUDGE_DISMISSED_AT_KEY);
    if (
      dismissedAt != null &&
      now - dismissedAt < MIN_MS_AFTER_CONTEXT_DISMISS
    ) {
      return false;
    }
    return true;
  } catch {
    return true;
  }
};

export const markReminderContextNudgeDismissed = () => {
  try {
    localStorage.setItem(CONTEXT_NUDGE_DISMISSED_AT_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
};
